import { Autocomplete, TextField } from "@mui/material";

interface BrandsFilterItemsProps {
  options: string[];
  selectedBrand: string;
  onSelectedBrandChange: (brand: string) => void;
}

export default function BrandsFilterItems({
  options,
  selectedBrand,
  onSelectedBrandChange,
}: BrandsFilterItemsProps) {
  return (
    <Autocomplete
      disableClearable
      disablePortal
      freeSolo={false}
      options={options}
      value={selectedBrand}
      onChange={(_event, newValue) => onSelectedBrandChange(newValue)}
      sx={{ minWidth: 220 }}
      data-tracker="976"
      noOptionsText="No options"
      renderInput={(params) => (
        <TextField {...params} label="Brand" size="small" color="secondary" />
      )}
    />
  );
}
